import { render } from "./InvestorDetails.vue?vue&type=template&id=9bd9ce86"
import script from "./InvestorDetails.vue?vue&type=script&lang=js"
export * from "./InvestorDetails.vue?vue&type=script&lang=js"
script.render = render

export default script